import { createRouter, createWebHistory } from "vue-router";

import AlertsView from "./views/AlertsView.vue";
import OverviewView from "./views/OverviewView.vue";
import ProfileView from "./views/ProfileView.vue";
import ReportsView from "./views/ReportsView.vue";
import SitesView from "./views/SitesView.vue";
import StudioNativeView from "./views/StudioNativeView.vue";
import MayaView from "./views/MayaView.vue";
import FilesView from "./views/FilesView.vue";
import PlanView from "./views/PlanView.vue";
import DistributionView from "./views/DistributionView.vue";  // GEO_EXEC_R14
import AccountView from "./views/AccountView.vue";
import PartnerView from "./views/PartnerView.vue";
import ArticleComposerView from "./views/ArticleComposerView.vue";

export const APP_VIEWS = [
  "overview",
  "add",
  "maya",
  "plan",
  "distribution",
  "files",
  "alerts",
  "reports",
  "sites",
  "profile",
  // FE-5 · these five are no longer entries in the rail. Impact and Fact check became Reports
  // tabs and Pages folded into Sites, but every one of them was a link somebody could have
  // bookmarked (and Maya's older cards still carry them), so the paths stay listed here and the
  // routes below redirect them. The five insight views are the same story from FE-1.
  "pages",
  "impact",
  "fact-check",
  "competitors",
  "citations",
  "prompts",
  "sentiment",
  "crawlers",
];

/** Reports' tabs, in the order they are shown. `overview` is the report log itself.
 *
 * FE-5 put `impact` and `facts` at the front: what your GEO site changed, and what the web gets
 * wrong about you, are the two questions a client opens Reports with. The four cuts of the
 * diagnosis and the crawler log follow. */
export const REPORT_TABS = ["overview", "impact", "facts", "competitors", "citations", "prompts", "sentiment", "crawlers"];

/** `/competitors` → `/reports?tab=competitors`, keeping whatever else the old link carried. */
function toReportsTab(tab) {
  return (to) => ({ path: "/reports", query: { ...to.query, tab }, replace: true });
}

export function historyBase() {
  const path = window.location.pathname || "/app/";
  const idx = path.indexOf("/app");
  if (idx < 0) return "/app/";
  return path.slice(0, idx) + "/app/";
}

export function createAppRouter() {
  return createRouter({
    history: createWebHistory(historyBase()),
    routes: [
      { path: "/", redirect: "/maya" },
      { path: "/overview", component: OverviewView, meta: { title: "Overview" } },
      { path: "/studio", component: StudioNativeView, meta: { title: "Studio" } },
      { path: "/maya", component: MayaView, meta: { title: "Maya" } },
      { path: "/add", redirect: "/maya" },
      { path: "/plan", component: PlanView, meta: { title: "Plan" } },
      { path: "/distribution", component: DistributionView, meta: { title: "Distribution" } },  // GEO_EXEC_R14
      { path: "/files", component: FilesView, meta: { title: "Files" } },
      { path: "/articles/new", component: ArticleComposerView, meta: { title: "Article composer" } },
      { path: "/alerts", component: AlertsView, meta: { title: "Alerts" } },
      { path: "/reports", component: ReportsView, meta: { title: "Reports" } },
      { path: "/sites", component: SitesView, meta: { title: "Sites" } },
      { path: "/profile", component: ProfileView, meta: { title: "Profile" } },
      // FE-5 · the three entries the rail lost, kept alive as redirects.
      { path: "/impact", redirect: toReportsTab("impact") },
      { path: "/fact-check", redirect: toReportsTab("facts") },
      { path: "/pages", redirect: (to) => ({ path: "/sites", query: { ...to.query, section: "comparisons" }, replace: true }) },
      { path: "/competitors", redirect: toReportsTab("competitors") },
      { path: "/citations", redirect: toReportsTab("citations") },
      { path: "/prompts", redirect: toReportsTab("prompts") },
      { path: "/sentiment", redirect: toReportsTab("sentiment") },
      { path: "/crawlers", redirect: toReportsTab("crawlers") },
      { path: "/account/:account(settings|email|orders|billing)", component: AccountView, meta: { title: "Account" } },
      { path: "/account/partner", component: PartnerView, meta: { title: "Partner Program" } },
      { path: "/:pathMatch(.*)*", redirect: "/maya" },
    ],
  });
}
